import { useRef } from "react";
import { motion } from "framer-motion";
import { Clock, Users, FileX, TrendingDown, Brain } from "lucide-react";
const problems = [{
  icon: Clock,
  title: "Migliaia di candidature. E tassi di non risposta dei candidati oltre il 40%",
  description: "Settimane per scremare CV e organizzare colloqui"
}, {
  icon: Users,
  title: "Talenti persi perché contattati troppo tardi, o scartati in pre-screening massivi",
  description: "I migliori candidati accettano altre offerte mentre aspettano"
}, {
  icon: FileX,
  title: "Tempo perso in attività non a valore: rispondere a domande dei candidati, pre-screening",
  description: "Migliaia di candidature restano in coda senza risposta"
}, {
  icon: TrendingDown,
  title: "Candidati scontenti in attesa di feedback o ingiustamente scartati",
  description: "Decisioni inconsistenti basate su impressioni superficiali"
}, {
  icon: Brain,
  title: "Disallineamento con gli Hiring Manager in termini di specifiche di ricerca",
  description: "Candidati abbandonati senza sapere perché"
}];
const ProblemCards = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  return <div className="w-full overflow-hidden py-4">
      <div ref={containerRef} className="flex gap-4 overflow-x-auto pb-4 px-2 snap-x snap-mandatory scrollbar-hide" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }}>
        {problems.map((problem, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} whileHover={{
        scale: 1.02,
        y: -5
      }} className="snap-center flex-shrink-0 w-[280px] md:w-[320px]">
            <div className="h-full bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#8B5CF6]/10 to-[#FFB6C1]/20 flex items-center justify-center mb-4">
                <problem.icon className="w-6 h-6 text-[#8B5CF6]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {problem.title}
              </h3>
              
            </div>
          </motion.div>)}
      </div>
      
      {/* Scroll indicator */}
      <div className="flex justify-center gap-1.5 mt-4">
        {problems.map((_, index) => <div key={index} className="w-2 h-2 rounded-full bg-gray-300" />)}
      </div>
      <p className="text-center text-sm text-gray-400 mt-2">← Scorri per vedere i problemi →</p>
    </div>;
};
export default ProblemCards;